// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__8DojF","label":"Completed_label__1FHtm"};